var prefix = 'ak-editor-sync-block';
export var SyncBlockSharedCssClassName = {
  prefix: prefix,
  renderer: "".concat(prefix, "__renderer")
};
var bodiedPrefix = 'ak-editor-bodied-sync-block';
export var BodiedSyncBlockSharedCssClassName = {
  prefix: bodiedPrefix,
  content: "".concat(bodiedPrefix, "__content")
};
var labelClassName = 'ak-editor-sync-block__label';
export var SyncBlockLabelSharedCssClassName = {
  labelClassName: labelClassName
};